"use client";

import { useState } from "react";
import { PortableText } from "next-sanity";
import dynamic from "next/dynamic";

const InternalLink = dynamic(
  () => import("@/components/common/internal-link"),
  {
    ssr: false,
  },
);

const FaqRow = ({ question, answer }: { question: string; answer: any }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="card-border flex flex-col justify-center rounded-lg border border-[#E5EAF4] bg-white pb-8 pl-4 pr-8 pt-8 md:p-[32px]">
      <button
        onClick={() => setIsOpen((prevIsOpen) => !prevIsOpen)}
        className="flex w-full cursor-pointer items-center justify-between text-left"
      >
        <span className="text-[18px] font-semibold text-slate-700 md:text-[20px]">
          {question}
        </span>
        <span className="text-[22px] font-semibold leading-normal text-[#00698F]">
          {isOpen ? "−" : "+"}
        </span>
      </button>
      {isOpen && (
        <div className="mt-3 text-[16px] leading-relaxed text-slate-600 md:text-[18px]">
          {answer && (
            <PortableText
              onMissingComponent={() => null}
              value={answer}
              components={{
                block: {
                  normal: ({ children }) => (
                    <p className="!py-1 text-[16px] text-[#373A36] md:text-[18px]">
                      {children}
                    </p>
                  ),
                },
                types: {
                  undefined: () => null,
                },
                marks: {
                  unknownMark: () => null,
                  internalLink: ({ children, value }: any) => (
                    <InternalLink value={value}>{children}</InternalLink>
                  ),
                  link: ({ children, value }) => (
                    <a
                      href={value.href}
                      className="text-[16px] font-normal leading-[135%] tracking-[-0.18px] text-[#00698F] underline md:text-[18px]"
                    >
                      {children}
                    </a>
                  ),
                },
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default FaqRow;
